var map = {
	"./Accord-gs.png": "6ad1",
	"./Accord.png": "450a",
	"./Adotas.png": "6e52",
	"./Adweek.png": "bebe",
	"./Alfa-Bank.png": "cd32",
	"./Appdate-gs.png": "ea77",
	"./Appdate.png": "e3e2",
	"./Bosson-gs.png": "864f",
	"./Bosson.png": "7a7e",
	"./Breggfast-gs.png": "ede8",
	"./Breggfast.png": "30f8",
	"./Coinspeaker.png": "7eb1",
	"./Economic-Times.png": "a94d",
	"./Finhead-gs.png": "c258",
	"./Finhead.png": "b918",
	"./Sberbank.png": "dc7a",
	"./TNW.png": "8fae",
	"./Tinkoff-bank.png": "8d72",
	"./VTB24.png": "9715"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e207";